export default function copyLink() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.th-copy-link');
    if (!btn) return;

    const url = btn.dataset.url;
    if (!url) return;

    navigator.clipboard.writeText(url).then(() => {
      btn.classList.add('is-copied');
      setTimeout(() => btn.classList.remove('is-copied'), 2000);
    }).catch(() => {
      // Fallback: select from temporary input
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      btn.classList.add('is-copied');
      setTimeout(() => btn.classList.remove('is-copied'), 2000);
    });
  });
}
